<template>
  <section class="hero-b2b py-4 position-relative overflow-hidden">
    <div class="container position-relative z-index-2">
      <!-- Pacientes Directory Quick Link Badge -->
      <div class="row justify-content-center mb-4">
        <div class="col-auto">
          <a
            href="/directorio"
            class="patient-badge d-inline-flex align-items-center
              px-3 py-2 rounded-pill bg-white shadow-sm border
              text-decoration-none text-dark"
            @click.prevent="$emit('open-directory')"
          >
            <span class="mr-2">🔍</span>
            <span class="small font-weight-bold">
              ¿Eres paciente? Busca a tu médico en el Directorio
            </span>
            <span class="badge badge-primary-base ml-2">Ir</span>
          </a>
        </div>
      </div>

      <div class="row align-items-center min-vh-70">
        <!-- Text Column -->
        <div class="col-lg-6 text-left mb-5 mb-lg-0">
          <div
            class="badge badge-light-success text-success-dark
              font-weight-bold px-3 py-2 mb-3 rounded-pill
              d-inline-block shadow-xs"
          >
            ✨ Plataforma #1 de Salud con IA
          </div>
          <h1
            class="display-4 font-weight-bold text-dark-blue
              line-height-12 mb-3"
          >
            Transforma tu consulta médica: Tu asistente con IA atiende 24/7.
          </h1>
          <p class="lead text-muted mb-4 font-weight-normal">
            Libérate de responder mensajes en "tus descansos".
            <strong>AMII</strong> atiende las dudas de tus pacientes,
            agenda citas automáticamente por WhatsApp y te ahorra hasta
            2 horas diarias de trabajo administrativo.
          </p>

          <!-- CTAs -->
          <div
            class="d-flex flex-column flex-sm-row align-items-stretch
              align-items-sm-center mb-4"
          >
            <a
              href="https://amii.app/soy-medico"
              class="btn btn-success-base btn-lg btn-pulse-success
                px-4 py-3 font-weight-bold rounded-lg shadow-md
                mb-3 mb-sm-0 mr-sm-3 text-white text-decoration-none
                text-center"
              @click.prevent="$emit('start-register')"
            >
              Prueba AMII Gratis
              <small class="d-block font-weight-normal opacity-90">
                Empieza en menos de 3 minutos
              </small>
            </a>
            <button
              class="btn btn-outline-primary-base btn-lg px-4 py-3
                font-weight-bold rounded-lg text-center"
              @click="$emit('scroll-vsl')"
            >
              <font-awesome-icon
                icon="play-circle"
                class="mr-2"
              />
              Ver demostración (3 min)
            </button>
          </div>

          <!-- Quick Trust Badges -->
          <div class="d-flex align-items-center text-muted small mt-2">
            <div class="mr-3">
              <font-awesome-icon
                icon="check-circle"
                class="text-success-base mr-1"
              />
              Sin tarjeta de crédito
            </div>
            <div class="mr-3">
              <font-awesome-icon
                icon="check-circle"
                class="text-success-base mr-1"
              />
              Soporte inicial guiado
            </div>
            <div>
              <font-awesome-icon
                icon="check-circle"
                class="text-success-base mr-1"
              />
              Cancela cuando quieras
            </div>
          </div>
        </div>

        <!-- Visual Column / 3D WhatsApp Simulator Mockup -->
        <div class="col-lg-6">
          <div class="mockup-3d-wrapper">
            <div
              class="mockup-3d-card bg-white p-3 rounded-xl border
                shadow-lg position-relative"
            >
              <!-- Header Simulación -->
              <div
                class="d-flex align-items-center p-2 bg-primary-dark-base
                  text-white rounded-top-lg mb-3"
              >
                <div
                  class="avatar-circle bg-success-base text-white
                    font-weight-bold mr-2 d-flex align-items-center
                    justify-content-center"
                >
                  🤖
                </div>
                <div class="text-left">
                  <div class="font-weight-bold small mb-0">
                    AmiiBot (Asistente Médico)
                  </div>
                  <div class="text-success-light xx-small">
                    ● En línea | Respondiendo WhatsApp
                  </div>
                </div>
                <span class="ml-auto badge badge-success-base">
                  2:15 AM
                </span>
              </div>

              <!-- Chat Flow Animation Simulation -->
              <div
                class="chat-sim-body p-2 text-left small bg-light-gray
                  rounded mb-2"
                style="max-height: 280px; overflow-y: auto;"
              >
                <div
                  class="chat-msg patient bg-white border p-2
                    rounded-lg mb-2 shadow-xs"
                  style="max-width: 85%;"
                >
                  <span class="text-dark">
                    Hola Doctor, disculpe la hora. ¿Tiene disponibilidad
                    de cita para consulta mañana?
                  </span>
                  <div class="text-muted text-right x-small">
                    2:14 AM
                  </div>
                </div>

                <div
                  class="chat-msg bot bg-primary-light p-2 rounded-lg
                    mb-2 ml-auto shadow-xs border-primary-light"
                  style="max-width: 85%;"
                >
                  <span class="text-dark">
                    ¡Hola! Soy Amii, el asistente virtual del Dr. Roberto.
                    SÍ, tenemos disponible un cupo mañana a las 3:30 PM.
                    ¿Te gustaría agendarlo ahora?
                  </span>
                  <div class="text-primary-base text-right x-small">
                    2:15 AM ✓✓
                  </div>
                </div>

                <div
                  class="chat-msg patient bg-white border p-2
                    rounded-lg mb-2 shadow-xs"
                  style="max-width: 85%;"
                >
                  <span class="text-dark">
                    ¡Sí, por favor! A las 3:30 PM me queda perfecto.
                  </span>
                  <div class="text-muted text-right x-small">
                    2:15 AM
                  </div>
                </div>

                <div
                  class="chat-msg bot bg-success-light p-2 rounded-lg
                    ml-auto shadow-xs border-success-light"
                  style="max-width: 85%;"
                >
                  <span class="text-dark font-weight-bold">
                    ✅ Cita confirmada con éxito.
                  </span>
                  <p class="mb-0 text-dark small">
                    Ya guardé tu cupo en la agenda del doctor y te
                    envié el recordatorio. ¡Que descanses!
                  </p>
                  <div class="text-success-base text-right x-small">
                    2:16 AM ✓✓
                  </div>
                </div>
              </div>

              <!-- Floating Accent Badge -->
              <div
                class="floating-element position-absolute bg-white border
                  shadow-md p-3 rounded-lg text-left"
                style="bottom: -20px; left: -15px; width: 220px; z-index: 10;"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="rounded-circle bg-success-light text-success-base
                      p-2 mr-2"
                  >
                    ⚡
                  </div>
                  <div>
                    <div class="font-weight-bold text-dark small">
                      +2 Horas libres
                    </div>
                    <div class="x-small text-muted">
                      Ahorradas hoy por el bot
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroB2B',
};
</script>

<style scoped>
.hero-b2b {
  background: linear-gradient(135deg, #f1f6ff 0%, #ffffff 100%);
}
.text-dark-blue {
  color: #002196;
}
.line-height-12 {
  line-height: 1.2;
}
.avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.chat-sim-body {
  background-color: #f8f9fa;
}
.min-vh-70 {
  min-height: 70vh;
}
.mockup-3d-wrapper {
  perspective: 1500px;
}
.mockup-3d-card {
  transform: rotateY(-8deg) rotateX(2deg);
  transition: transform 0.5s ease;
}
.mockup-3d-card:hover {
  transform: rotateY(0deg) rotateX(0deg);
}
@media (max-width: 991.98px) {
  .mockup-3d-card {
    transform: none;
  }
  .min-vh-70 {
    min-height: auto;
  }
}
.badge-light-success {
  background-color: #d1f2e2;
}
.text-success-dark {
  color: #02592d;
}
.bg-success-light {
  background-color: #e8f8f0;
  border: 1px solid #c2f0d8;
}
.bg-primary-light {
  background-color: #eef5ff;
  border: 1px solid #cce2ff;
}
.xx-small {
  font-size: 0.7rem;
}
.x-small {
  font-size: 0.75rem;
}
</style>
